<h2 mat-dialog-title>
  Portal indstillinger
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <div fxLayout="column" formGroupName="cleanup">
      <p>Angiv værdier for hvornår læste/ulæste notifikationer slettes i portalen</p>
      <div fxLayout="row" fxLayoutGap="1em">
        <mat-form-field>
          <mat-label>Læste notifikationer</mat-label>
          <input
            type="number"
            matInput
            formControlName="noticed"
            >
          <mat-hint>Angiv værdi i dage.</mat-hint>
          @if (cleanup.get('notified')?.hasError('required')) {
            <mat-error><strong>Skal</strong> udfyldes.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ulæste notifikationer</mat-label>
          <input
            type="number"
            matInput
            formControlName="unnoticed"
            >
          <mat-hint>Angiv værdi i dage.</mat-hint>
          @if (cleanup.get('unnoticed')?.hasError('required')) {
            <mat-error><strong>Skal</strong> udfyldes.</mat-error>
          }
        </mat-form-field>
      </div>

    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
